module.exports = __webpack_public_path__ + "static/media/DemoChart.9b31ee35.JPG";